const DEFAULT_QUERY_NAMESPACE = 'root';


function urlToQueryKey(url) {
  return url.split('/');
}


/**
 * Cache-key prefix factory shared by the query + mutation modules (audit
 * 0839b321). Mirrors the `[namespace, ...url.split('/')]` rule `useBaseQuery`
 * applies: app URLs start with '/', so the split yields a leading '' segment —
 * reproduced here as the fixed `[DEFAULT_QUERY_NAMESPACE, '']` head. Segments are
 * appended verbatim (no coercion) so the number-vs-string types in each key match
 * the runtime keys byte-for-byte; callers keep their own `String(sellerId || '')`
 * wrapping where they had it.
 */
function queryKeyPrefix(...segments) {
  return [DEFAULT_QUERY_NAMESPACE, '', ...segments];
}


export { DEFAULT_QUERY_NAMESPACE, queryKeyPrefix, urlToQueryKey };
